var render, staticRenderFns
import script from "./o-carousel-v1.vue?vue&type=script&lang=js"
export * from "./o-carousel-v1.vue?vue&type=script&lang=js"
import style0 from "./o-carousel-v1.vue?vue&type=style&index=0&id=37ef7738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ef7738",
  null
  
)

export default component.exports